import cn from 'classnames'
import React, { FC, useState, useEffect, useRef, useMemo, SyntheticEvent } from 'react'
import { ILabel } from 'types/Form'
import Tooltip from '../tooltip'
import s from './Label.module.css'

const Label = ({ id, text, className, tooltip, preventClick }: ILabel) => {
    return <label
        htmlFor={id}
        className={cn(s.root, className)}
        onClick={(e) => {
            if (preventClick) {
                e.preventDefault();
            }
        }}
    >
        {text}
        {tooltip && <Tooltip {...tooltip} />}
    </label>
}

export default Label;